import { Grid } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

export const Wrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "1.5rem",
  marginBottom: "1.5rem",
}));

interface GridAddressComponentProp {
  onCustomerView: boolean;
}
export const GridAddressComponent = styled(Grid)(
  ({ onCustomerView }: GridAddressComponentProp) => ({
    width: onCustomerView ? "calc(100% - 2px)" : "100%",
  })
);

const styles = makeStyles(() => ({
  tag: {
    backgroundColor: "#EDF5FB",
    borderRadius: 4,
    padding: "4px 8px",
    font: "600 12px/20px Manrope !important",
    color: "#308CDB !important",
  },
  wrapper: {
    marginBottom: 24,
    display: "flex",
    flexDirection: "column",
    gap: 24,
  },
  p08: {
    padding: "0 8px",
  },
}));

export default styles;
